// 10-07-2025
export const HOST_SELECTED = "HOST_SELECTED";

export const ADD_HOST_IDS = "ADD_HOST_IDS";

export const RESET_HOST = "RESET_HOST";